/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { injectable } from 'inversify';
import { ResetPasswordPageAgent, getAgent } from './agent';
import { ResetPasswordProps, HeaderProps } from './plugins';
import { DEFAULT_APP_CONFIG } from '@/config/default.config';

const is = require('is_js');

const SERVICE_NAME = 'ResetPasswordPageService';

@injectable()
export class ResetPasswordPageService {
  public agent: ResetPasswordPageAgent;
  static displayName = 'ResetPasswordPageService';
  private readonly loginRestAPI: string;
  private readonly signerPK: string;
  private headers: HeaderProps;

  constructor(props: any = {}) {
    this.agent = getAgent();
    this.loginRestAPI = props?.loginRestAPI;
    this.signerPK = props?.signerPK;
    this.headers = props?.headers;
  }

  public async getPageContent() {
    let content: any = {};
    let compProps: any = null;

    const agent = getAgent();
    const { token, decoded } = await agent?.parseAndDecodeToken({
      signerPK: DEFAULT_APP_CONFIG?.SIGNER_PK,
    });
    console.log('token =>', token);
    console.log('decoded =>', decoded);
    content = {
      ...content,
      initialData: {
        email: decoded?.email,
      },
      token: token,
    };
    return content;
  }
}
